module.exports = __webpack_public_path__ + "6ccfc765e5edef284785cb13bd01d0d1.pdf";